import { QueryFunctionContext } from '@tanstack/react-query'
import { GET } from '../../../redux/middleware/types'
import supplierEndpoints from '../api/supplierEndpoints'
import supplierQueryKeys from '../queries/supplierQueryKeys'
import integrationRequest from '../../../services/api/integrationRequest'
import { Supplier } from '../../../types/supplier/supplier'

export const getSuppliers = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof supplierQueryKeys)['list']>>): Promise<Supplier[]> => {
  if (!companyId || companyId === 'undefined') return []
  const suppliers = await integrationRequest<Supplier[]>({
    method: GET,
    url: supplierEndpoints.accounting(),
    signal,
    params: {
      companyId
    }
  })
  // Backend returns numeric ids; normalize to string to match Supplier.id and the rest of the app.
  return suppliers.map(supplier => ({ ...supplier, id: String(supplier.id) }))
}
